import { smartSchedulingEndpoint } from "../endpoints";

export async function declineSmartSchedulingAvailability(userToken: string) {
  const response = await fetch(
    `${smartSchedulingEndpoint}/${userToken}/decline`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    return response.json();
  }

  return response.json();
}
